import { Header, Trigger } from '@radix-ui/react-accordion'
import { IconChevronDown } from '@tabler/icons-react'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'

export interface AccordionTriggerProps extends ComponentPropsWithoutRef<
  typeof Trigger
> {
  hideChevron?: boolean
}

export const AccordionTrigger = forwardRef<
  ElementRef<typeof Trigger>,
  AccordionTriggerProps
>(({ className, children, hideChevron = false, ...props }, ref) => (
  <Header asChild>
    <Trigger
      ref={ref}
      className={cn(
        'group flex w-full flex-1 items-center justify-between p-4 text-start font-medium hover:underline focus-visible:underline focus-visible:outline-hidden',
        className
      )}
      {...props}
    >
      {children}
      {!hideChevron && (
        <IconChevronDown className="size-4 shrink-0 transition-transform duration-200 group-data-[state=open]:rotate-180" />
      )}
    </Trigger>
  </Header>
))
AccordionTrigger.displayName = Trigger.displayName
